import { FunctionComponent, SyntheticEvent, useContext, useEffect, useState } from "react";
import styles from "./Tickets.module.css";
import {
  Dialog,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  ThemeProvider,
  Button,
  createTheme,
} from "@mui/material";
import ManageTickets from "../../components/shared-components/ticket/ManageTickets";
import ListTickets from "../../components/shared-components/ticket/ListTickets";
import images from "../../assets/images/index";
import ManageTicketFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/ManageTicketFilterDropdown";
import { DELIST_TICKET, DELIST_TICKETS, EDIT_TICKET_PRICE_BY_SUPER_USER, FORCE_UPDATE_TICKET, GET_EDIT_TICKET_DETAIL, PUBLISH_TICKETS, RETURN_TICKET, UNDO_DELIST_REQUEST_TO_LIST, VALIDATE_UPDATE } from "./api/TicketsQuery";
import ToasterWithMessage from "../../components/shared-components/toaster";
import { useLazyQuery, useMutation } from "@apollo/client";
import { globalContext } from "../../Provider/AppProvider";
import ListTicketFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/ListTicketFilterDropdown";
import { CustomPaperComponent, EditTicketType, roles } from "../../helper";
import { getNotificationQueryVariables } from "../../utils/notification-query-variables";
import { isVictoryLivePriceUpdateSuccess, priceUpdateFailureMessage } from "../ManageTickets/priceUpdateResult";
import PublishPopup from "../../components/shared-components/success-popup/PublishPopup";
import SoldTickets from "../../components/shared-components/ticket/SoldTickets";
import SoldTicketFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/SoldTicketFilterDropdown";
import { GET_NOTIFICATIONS } from "../../components/shared-components/notification/api/NotificationQuery";
import EditTicketPopUp from "../../components/shared-components/success-popup/EditTicketPopUp";
import DelistAndReturnFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/DelistAndReturnFilterDropdown";
import DelistAndReturnTickets from "../../components/shared-components/ticket/DelistAndReturnTickets";
import DelistAndUnsold from "../../components/shared-components/ticket/DelistAndUnsold";
import DelistAndUnsoldFilterDropdown from "../../components/shared-components/dropdown/filter-dropdown/DelistAndUnsoldFilterDropdown";
import { NumberEditPopup } from "../../components/shared-components/success-popup/NumberEditPopup";

const theme = createTheme({
  palette: {
    primary: {
      main: "#5D75F8",
    },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "Glegoo",
          fontWeight: 700,
          fontSize: "14px",
          textTransform: "capitalize",
        },
      },
    },
  },
});

interface ManageTicketDataType{
  e_name: string,
  l_name: string,
  e_date: string,
  e_address: string,
  tp_section: string,
  tp_row: string,
  tp_seat_no: string,
  u_id: string,
  u_first_name: string,
  u_last_name: string,
  tp_validity_status: boolean,
  tp_status: string,
  tp_is_published: boolean,
  e_id: string,
  t_id: string,
  tp_id: string,
  e_status:string,
  user: {
    u_role: string
  }
}

interface ListTicketDataType{
  e_address:string, 
  e_brand_name:string,
  e_date:string,
  e_date_time_zone:string,
  e_id:string,
  e_name:string,
  e_status:string,
  e_time_zone:string,
  l_name:string,
  t_id:string,
  tp_delist_requested_email:string | null,
  tp_id:string,
  tp_is_support_vanderbilt_nil_fund:boolean,
  tp_list_price:number,
  tp_row:string,
  tp_seat_no:number,
  tp_section:string,
  tp_status:string,
  u_email_id:string,
  u_first_name:string,
  u_full_name:string,
  u_id:string,
  u_last_name:string,
  u_original_email:string | null ,
}
const Tickets: FunctionComponent = () => {
  const { dropdownIcon, GreyFilterIcon} = images;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  localStorage.removeItem('settingsTabIndex');
  localStorage.removeItem('errorTabIndex');
  const tab=localStorage?.getItem('ticketsTabIndex');
  const [activeTab, setActiveTab] = useState(localStorage.getItem('ticketsTabIndex')&&tab?parseInt(tab):0);
  const [anchorElFilter, setAnchorlFilter] = useState(null);
  const openFilter = Boolean(anchorElFilter);
  const {error,success,info} = ToasterWithMessage();
  const {globalState,handleGlobalState} = useContext<any>(globalContext)

  const handleChangeTab = (_e: SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    localStorage.setItem('ticketsTabIndex',String(newValue));
  };
  const handleClickOpenmenu = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
 
  const [getWebNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempData = {...globalState}
      tempData.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempData.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempData)
    }
  })

useEffect(() => {
  getWebNotification({
    variables: getNotificationQueryVariables(globalState?.profile?.id),
  });
// eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

  const handleClickopenFilter = (event: any) => {
    setAnchorlFilter(event.currentTarget);
      const tempValues = {...globalState}
      if(globalState.notification.notificationClicked){
        tempValues.notification.notificationClicked = false;
        tempValues.notification.tp_id_array=null;
        tempValues.globalSearch.searchtext = "";
        tempValues.notification.text = "";
        tempValues.notification.ticketId =null;
        tempValues.notification.tpId = null;
        handleGlobalState(tempValues)
      }else if(globalState.error.errorClicked){
        tempValues.error.errorClicked = false;
        tempValues.globalSearch.searchtext = "";
        tempValues.error.text = "";
        tempValues.error.approximateTpArray = null
        tempValues.error.ticketPlacementId = null
        tempValues.error.status = ""
        handleGlobalState(tempValues)
      }
  };

  const handleClose = () => {
    setAnchorlFilter(null);
  };

  const [selected, setSelected] = useState<number[]>([]);
  const [columnTypes, setColumnTypes] = useState('tp_updated_at');
  const [sortType, setSortType] = useState('desc');
  const [tempRowsPerPage, setTempRowsPerPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(tempRowsPerPage ? tempRowsPerPage : '') || 10);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageList, setCurrentPageList] = useState(1);
  const [currentPageSold, setCurrentPageSold] = useState(1);
  const [currentPageReturn, setCurrentPageReturn] = useState(1);
  const [currentPageUnsold, setCurrentPageUnsold] = useState(1);
  const [checking,setChecking]=useState<boolean>(false);
  const [manageTicketList,setManageTicketList] = useState<any>([{}]);
  const [listTicketList,setListTicketList] = useState<any>([{}]);
  const [delistAndReturnTicketList,setDelistAndReturnTicketList] = useState<any>([{}]);
  const [soldTicketList,setSoldTicketList] = useState<any>([{}])
  const [unsoldTicketList,setUnsoldTicketList] = useState<any>([{}])
  const [selectedTickets, setSelectedTickets] = useState<string[]>([]);
  const [listTempRowsPerPage, setListTempRowsPerPage] = useState();
  const [soldTempRowsPerPage, setsoldTempRowsPerPage] = useState();
  const [unsoldTempRowsPerPage, setUnsoldTempRowsPerPage] = useState();
  const [returnTempRowsPerPage, setReturnTempRowsPerPage] = useState();
  const [ListRowsPerPage, setListRowsPerPage] = useState(parseInt(listTempRowsPerPage ? listTempRowsPerPage : '') || 10);
  const [SoldRowsPerPage, setSoldRowsPerPage] = useState(parseInt(soldTempRowsPerPage ? soldTempRowsPerPage : '') || 10);
  const [ReturnRowsPerPage, setReturnRowsPerPage] = useState(parseInt(returnTempRowsPerPage ? returnTempRowsPerPage : '') || 10);
  const [UnsoldRowsPerPage, setUnsoldRowsPerPage] = useState(parseInt(unsoldTempRowsPerPage ? unsoldTempRowsPerPage : '') || 10);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogReturn, setOpenDialogReturn] = useState(false);
  const [openDialogBulkDelist,setOpenDialogBulkDelist]=useState(false);
  const [openDialogBulkList,setOpenDialogBulkList]=useState(false);
  const [openDialogEditPrice,setOpenDialogEditPrice]=useState(false);
  const [listDetails,setListDetails]=useState<string[]>([]);
  const [ticketCount, setTicketCount] = useState<number>(0);
  const StyledComponent = CustomPaperComponent();

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setTempRowsPerPage(event.target.value);
    setCurrentPage(1);
    setSelectedTickets([])
    setSelected([])
  };
  const handleChangeListRowsPerPage =(event: any) =>{
    setListRowsPerPage(parseInt(event.target.value, 10));
    setListTempRowsPerPage(event.target.value);
    setCurrentPageList(1);
  }

  const handleChangeSoldRowsPerPage =(event: any) =>{
    setSoldRowsPerPage(parseInt(event.target.value, 10));
    setsoldTempRowsPerPage(event.target.value);
    setCurrentPageSold(1);
  }
  const handleChangeReturnRowsPerPage =(event: any) =>{
    setReturnRowsPerPage(parseInt(event.target.value, 10));
    setReturnTempRowsPerPage(event.target.value);
    setCurrentPageReturn(1);
  }

  const handleChangeUnsoldRowsPerPage =(event: any) =>{
    setUnsoldRowsPerPage(parseInt(event.target.value, 10));
    setUnsoldTempRowsPerPage(event.target.value);
    setCurrentPageUnsold(1);
  }

  const handlePageChange = (_event: React.ChangeEvent, newPage: number) => {
    setCurrentPage(newPage);
    setChecking(false)
    setSelected([]);
    setSelectedTickets([])
  };
  const handlePageChangeList = (_event: React.ChangeEvent, newPage: number) => {
    setCurrentPageList(newPage);
  };
  const handlePageChangeSold = (_event: React.ChangeEvent, newPage: number) => {
    setCurrentPageSold(newPage);
  };
  const handlePageChangeReturn = (_event: React.ChangeEvent, newPage: number) => {
    setCurrentPageReturn(newPage);
  };
  const handlePageChangeUnsold = (_event: React.ChangeEvent, newPage: number) => {
    setCurrentPageUnsold(newPage);
  };

  const handleCloseDialogBulkList = () =>{
    setOpenDialogBulkList(false)
  }

  const handleCloseDialogBulkDelist = () =>{
    setOpenDialogBulkDelist(false)
  }

  const handleCloseDialogEditPrice = () =>{
    setOpenDialogEditPrice(false)
  }

  const handleBulkPriceUpdate = async(price: number) => {
   
    handleGlobalState((prev: { loadingFormarkassold: { soldloader: boolean; }; }) => ({
      ...prev,
      loadingFormarkassold: { soldloader: true },
    }));
    handleCloseDialogEditPrice();


    if (!selectedTickets || selectedTickets.length === 0) return;
    await editTicketPrice({
      variables:{
        tp_ids:selectedTickets,
        tp_list_price:Number(price),
      }
    })
      setCurrentPage(1);
      setSelectedTickets([]);
      setSelected([]);
      handleGlobalState((prev: { loadingFormarkassold: { soldloader: boolean; }; }) => ({
      ...prev,
      loadingFormarkassold: { soldloader: false },
    }));
      
  };

  const handleOpenDialogEditPrice = () =>{
    if(selectedTickets.length >0){
      handleCloseMenu();
      setOpenDialogEditPrice(true);
    }else if(selectedTickets.length === 0){
      error("Please select records")
      setSelected([]);
      setSelectedTickets([]);
    };
  } 
  const [validateUpdateBulk] = useMutation(VALIDATE_UPDATE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data) {
      const message = data?.updateTicketStatus?.message;
      const lowerMsg = message.toLowerCase();
      if (
        lowerMsg.includes("successfully") &&
        lowerMsg.includes("not available in logitix")
      ) {
        info(message); 
      } else if (lowerMsg.includes("successfully")) {
        success(message);
      } else {
        info(message);
      }
       const tempState = {...globalState}
       tempState.ticketUpdate.updatedticket = true
       handleGlobalState(tempState)
      }
      setTicketCount(0)
      setCurrentPage(1);
      setSelectedTickets([]);
      setSelected([]);
    },
    onError: (err) => {
      const backendErrorMessage =
      err?.graphQLErrors?.[0]?.message ||
      err?.networkError?.message ||
      "Something went wrong!";
      error(backendErrorMessage);
    },
  });

  const [editTicketPrice] = useMutation(EDIT_TICKET_PRICE_BY_SUPER_USER, {
    fetchPolicy: "network-only",
    onCompleted:(data)=>{
      const message = data?.editTicketPriceBySuperUser?.message;
      if (!isVictoryLivePriceUpdateSuccess(message)) {
        error(priceUpdateFailureMessage(message));
        return;
      }
      success(message);
      const tempState ={...globalState};
      tempState.ticketUpdate.listPrice = true ;
      handleGlobalState(tempState);
    },
    onError:(err)=>{
      error(err?.message?.includes("not a valid json response from webhook") ? "Not a valid response from webhook" : err?.message || "Not a valid response from webhook" );
    }
  });

  const [publishBulk] = useMutation(PUBLISH_TICKETS, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (data && data?.publishTickets?.message) {
        success(data?.publishTickets?.message);
       const tempState = {...globalState}
       tempState.publishBulkticket.publishBulk = true
       handleGlobalState(tempState)
      }
      setTicketCount(0)
      setSelectedTickets([])
      setSelected([])
    },
    onError: (err) => {
      const backendErrorMessage =
      err?.graphQLErrors?.[0]?.message ||
      err?.networkError?.message ||
      "Something went wrong!";
      error(backendErrorMessage);
    },
  });

  const [returnTicketByAdmin] = useMutation(RETURN_TICKET,{
    fetchPolicy: 'no-cache',
    onCompleted: (data) =>{
      if(data?.returnTickets?.message){
      setColumnTypes('tp_updated_at')
      setSortType('desc')
      success(data?.returnTickets?.message)
      const tempState = {...globalState};
      tempState.ticketUpdate.returnTicket = true
      handleGlobalState(tempState);
      }
    },
    onError: (err) =>{
      error(err.message)
    }
  })

  const modifyValidStatus = (value: boolean) => {
    handleCloseMenu();
    let tobeActiveTickets : string [] = []
    let toBeDeactivateTickets : string [] = []
    let tobeActiveTicketsUserrole : string [] = []
    if(selectedTickets.length >0){
      if(value === true){
      selectedTickets?.map((id: string)=>{
        return manageTicketList?.filtermanagetickets?.map((ticket: ManageTicketDataType)=>{
          if(id === ticket?.tp_id){
            if((ticket?.user?.u_role === 'admin')||(ticket?.user?.u_role === 'logitix_user') || (ticket?.user === null)){
              if(ticket?.tp_validity_status === null || ticket?.tp_validity_status === false){
              if((ticket?.e_status!=='closed'&& ticket?.e_status!=="cancelled")){
              tobeActiveTickets.push(ticket?.tp_id)
              }
              }
            }
            else if ((ticket?.user?.u_role === 'user') ){
              if(ticket?.tp_validity_status === null){
                if((ticket?.e_status!=='closed'&& ticket?.e_status!=="cancelled")){
                tobeActiveTicketsUserrole.push(ticket?.tp_id)
                }
                }
            }
          }
          return ticket?.tp_id
        })
      })
       if((tobeActiveTickets.length === 0 && tobeActiveTicketsUserrole.length === 0) || (tobeActiveTickets.length === 0)){
        error(`Can't valid, verified or delist or delist in progress tickets`);
      }
    }else if(value === false){
      selectedTickets?.map((id: string)=>{
        return manageTicketList?.filtermanagetickets?.map((ticket: ManageTicketDataType)=>{
          if(id === ticket?.tp_id){
            if((ticket?.user?.u_role === 'admin') ||(ticket?.user?.u_role === 'logitix_user')|| (ticket?.user === null) || (ticket?.user?.u_role === 'user')){
              if((ticket?.tp_validity_status === true )|| (ticket?.tp_validity_status === null)){
              toBeDeactivateTickets.push(ticket?.tp_id)
              }
            }
          }
          return ticket?.tp_id
        })
      })
      if(toBeDeactivateTickets.length  === 0){
        error(`Can't invalid, Delist tickets`)
      }
    }
      setTicketCount(tobeActiveTickets.length ? tobeActiveTickets.length : toBeDeactivateTickets?.length ? toBeDeactivateTickets.length : 0)
      setColumnTypes("tp_updated_at");
      setSortType("desc");
    if(tobeActiveTickets.length > 0 || toBeDeactivateTickets.length> 0){ 
    validateUpdateBulk({
      variables: {
        isValid: value,
        ticketPlacementId: (tobeActiveTickets?.length)? tobeActiveTickets : (toBeDeactivateTickets?.length) ? toBeDeactivateTickets : selectedTickets
      },
    });}
    setSelected([]);
    setSelectedTickets([]);
    }else if(selectedTickets.length === 0){
      error("Please select records")
      setSelected([]);
      setSelectedTickets([]);
    }
  };

  const [listTicketByAdmin] = useMutation(UNDO_DELIST_REQUEST_TO_LIST, {
      fetchPolicy: 'no-cache',
      onCompleted: (data) =>{
        if(data?.undoDelistRequestToList?.message){
        setColumnTypes('tp_updated_at')
        setSortType('desc')
        success(data?.undoDelistRequestToList?.message)
        const tempState = {...globalState};
        tempState.ticketUpdate.listTicket  = true
        handleGlobalState(tempState);
        }
      },
      onError: (err) =>{
        error(err?.message)
      }
    })
    const [updateTicketStatus] = useMutation(VALIDATE_UPDATE,{
      fetchPolicy : 'no-cache',
      onCompleted:(data) =>{
        setColumnTypes('tp_updated_at')
        setSortType('desc')
        success("Ticket Delisted Successfully")
        const tempState = {...globalState};
        tempState.ticketUpdate.delistTicket  = true
        handleGlobalState(tempState);
      },
      onError: () =>{
        error('Unable to Delist')
      }
    })
    
    const [delistTicketByAdmin] = useMutation(DELIST_TICKET,{
        fetchPolicy: 'no-cache',
        onCompleted: (data) =>{
          setColumnTypes('tp_updated_at')
          setSortType('desc')
          success("Ticket Delisted Successfully")
          const tempState = {...globalState};
          tempState.ticketUpdate.delistTicket  = true
          handleGlobalState(tempState);
        },
        onError: () =>{
          error('Unable to Delist')
        }
      })
      
   const selectedListTickets = () =>{
    let listedTickets: string [] = []
    selectedTickets?.map((id: string)=>{
      return listTicketList?.filterlisttickets?.map((ticket: ListTicketDataType)=>{
        if(id === ticket?.tp_id){
           if(ticket?.tp_status === "DelistInProgress"){
             listedTickets.push(ticket?.tp_id)
           }
        }
        return ticket?.tp_id;
      })
    })
    
    return listedTickets
  }

  const selectedDeListTickets = () =>{
    let delistedTickets: string [] = []
    selectedTickets?.map((id: string)=>{
      return listTicketList?.filterlisttickets?.map((ticket: ListTicketDataType)=>{
        if(id === ticket?.tp_id){
           if(ticket?.tp_status === "List"){
             delistedTickets.push(ticket?.tp_id);
           }
        }
        return ticket?.tp_id;
      })
    })  
    return delistedTickets
  }

  const handleOpenDialogBulkDelist = async()=>{
    if(selectedTickets.length >0){
      handleCloseMenu();
      setOpenDialogBulkDelist(true);
      const details = await selectedDeListTickets();
      setListDetails(details);
    }else if(selectedTickets.length === 0){
      error("Please select records")
      setSelected([]);
      setSelectedTickets([]);
    };
  }

  const handleOpenDialogBulkList = async()=>{
     if(selectedTickets.length >0){
    handleCloseMenu();
    setOpenDialogBulkList(true);
    const details = await selectedListTickets();
    setListDetails(details);
  }else if(selectedTickets.length === 0){ 
      error("Please select records")
      setSelected([]);
      setSelectedTickets([]);
    }
  }

  const [delistTickets] = useMutation(DELIST_TICKETS,{
      fetchPolicy : 'no-cache',
      onCompleted:(data) =>{
        setColumnTypes('tp_updated_at')
        setSortType('desc')
        const message = data?.delistTickets?.message;
        const normalized = message.toLowerCase();
        if (normalized.includes('failed') && message.includes('successfully')) {
          info(message);
        }else if(normalized.includes('successfully')){
          success(message);
        }else if(normalized.includes('failed')){
          error(message);
        }else{
          info(message);
        }
        const tempState = {...globalState};
        tempState.ticketUpdate.delistTicket  = true
        handleGlobalState(tempState);
      },
      onError: (err) =>{
        error(err?.message?.includes("not a valid json response from webhook") ? "Not a valid response from webhook" : err?.message || "Not a valid response from webhook" );
      }
    })

  const handleAllowDelist = async(event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenDialogBulkDelist(false);
    handleGlobalState((prev: { loadingFormarkassold: { soldloader: boolean; }; }) => ({
      ...prev,
      loadingFormarkassold: { soldloader: true },
    }));
    event.preventDefault()
    if (event) {
      if (!Array.isArray(listDetails) || listDetails.length === 0) return;
      await delistTickets({
        variables: {
          ticketPlacementIds: listDetails,
        },
      });
    }
    setSelected([]);
    setSelectedTickets([]);
    handleGlobalState((prev: { loadingFormarkassold: { soldloader: boolean; }; }) => ({
      ...prev,
      loadingFormarkassold: { soldloader: false },
    }));
  }

  const handleAllowList = (event : React.MouseEvent<HTMLButtonElement>) =>{
    event.preventDefault();
    if(event){
      setOpenDialogBulkList(false);
      if(!Array.isArray(listDetails) || listDetails.length === 0) return;
      listDetails.forEach((details)=>{
        listTicketByAdmin({
          variables:{
            tpId: details
          }
        })
    })
  }
}
  
  const selectedVerified = () =>{
    let publishTickets: string [] = []
    selectedTickets?.map((id: string)=>{
      return manageTicketList?.filtermanagetickets?.map((ticket: ManageTicketDataType)=>{
        if(id === ticket?.tp_id){
           if(ticket?.tp_status === "Verified"&& (ticket?.e_status!=='closed'&& ticket?.e_status!=="cancelled")){
             publishTickets.push(ticket.tp_id)
           }
        }
        return ticket?.tp_id
      })
    })
    return publishTickets
  }

  const selectedReturn = () =>{
    let returnTickets: string [] = [];
    let eventName: string | null = null;
    let eventDate: string | null = null;

    selectedTickets?.map((id: string)=>{
      return manageTicketList?.filtermanagetickets?.map((ticket: ManageTicketDataType)=>{
        if(id === ticket?.tp_id){
           if((ticket?.tp_status === "DelistInProgress"||ticket?.tp_status === "Delist") && (ticket?.e_status!=='closed'&& ticket?.e_status!=="cancelled")){
            if (eventName === null && eventDate === null) {
              // Set the initial event name and date from the first valid ticket
              eventName = ticket?.e_name;
              eventDate = ticket?.e_date;
          } else {
              // Check if the event name and date match the first valid ticket's event
              if (ticket?.e_name !== eventName || ticket?.e_date !== eventDate) {
                  error("Please select the same event to return the tickets!");
                  returnTickets = []
                  return returnTickets.push("Different events");
              }
          }
            returnTickets.push(ticket.tp_id)
           }
        }
        return ticket?.tp_id
      })
    })
    return returnTickets
  }


   //closes the success pop
   const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedTickets([])
    setSelected([])
  };

  const handleCloseDialogReturn = () => {
    setOpenDialogReturn(false);
    setSelectedTickets([])
    setSelected([])
  };

  const handleAllowpublish = (listPrice: number) =>{
      setOpenDialog(false)
      modifyPublishStatus(listPrice)
  }
  
  const handleAllowReturn = () =>{
    setOpenDialogReturn(false)
    modifyReturn()
}
  const handlepublish = () => {
    handleCloseMenu()
    let publishTicketsArray = selectedVerified()
    if(selectedTickets.length === 0){
      error("Please select records")
    }else if(publishTicketsArray.length === 0){
      error("No verified or active tickets in selected list!")
      setTimeout(() => {
        setSelectedTickets([]);
        setSelected([]);
      }, 2000);
      
    }else{
    setTicketCount(publishTicketsArray.length)
    setOpenDialog(true)
    }
  }
  const handleReturn = () => {
    handleCloseMenu()
    let returnTicketsArray = selectedReturn()
    if(selectedTickets.length === 0){
      error("Please select records")
    }else if(returnTicketsArray.length === 0){
      error("No Delist or Delist requested or active tickets in selected list!")
      setTimeout(() => {
        setSelectedTickets([]);
        setSelected([]);
      }, 2000);     
    }else if(returnTicketsArray[0] === "Different events"){
      setTimeout(() => {
        setSelectedTickets([]);
        setSelected([]);
      }, 2000);
    }else{
    setTicketCount(returnTicketsArray.length)
    setOpenDialogReturn(true)
    }
  }

  const modifyPublishStatus = (listPrice: number) => {   
    handleCloseMenu()
    let publishTickets = selectedVerified()
    if(publishTickets.length >0){
    publishBulk({
      variables:{
        publishTicketsInput:{
          ticketPlacementIds :publishTickets,
          listPrice:listPrice
          }
      }
    })
  }else{
    setSelectedTickets([])
    setSelected([])
  }
  }

  const modifyReturn = () => {   
    handleCloseMenu()
    let returnTickets = selectedReturn()
    if(returnTickets.length > 0){
      returnTicketByAdmin({
        variables:{
          ticketPlacementId: returnTickets
        }
     });
    }else{
    setSelectedTickets([])
    setSelected([])
  }}

/* For get the ManageTicket table headers */
  const GenerateManageTicketHeadCells = ()=>{
    const id = globalState.profile.userRole === "logitix_user"?["e_name","e_date","e_address","e_date","tp_section","validate","tp_status","tp_delist_requested_email",'periodleft',"action"]:globalState.profile.userRole === roles.SUPER_USER?["e_name","e_date","e_address","e_date","tp_section","tp_status","tp_delist_requested_email",'periodleft']:["e_name","e_date","e_address","e_date","tp_section","validate","tp_status","tp_is_support_vanderbilt_nil_fund","tp_delist_requested_email","full_name","u_email_id",'periodleft',"action"];
    const labels = globalState.profile.userRole === "logitix_user"?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Validate","Status","Return Email","Period Left","Action"]:globalState.profile.userRole === roles.SUPER_USER?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Status","Return Email","Period Left"]:["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Validate","Status","Donation Status","Return Email","User Name","Email","Period Left","Action"];
    const headCells = id.map((id, index) => ({
        id,
        label: labels[index],
      }));
      return headCells;
}

/*For get the ListTicket table headers */
const GenerateListTicketHeadCells = ()=>{
  const id = globalState.profile.userRole === "logitix_user"?["e_name","e_date","e_address","e_date","tp_section","tp_status","tp_delist_requested_email","tp_list_price","action"]:globalState.profile.userRole === roles.SUPER_USER?["e_name","e_date","e_address","e_date","tp_section","tp_status","tp_delist_requested_email","tp_list_price"]:["e_name","e_date","e_address","e_date","tp_section","tp_status","tp_is_support_vanderbilt_nil_fund","tp_delist_requested_email","full_name","u_email_id","tp_list_price","action"];
  const labels = globalState.profile.userRole === "logitix_user"?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Status","Return Email","List Price","Action"]:globalState.profile.userRole === roles.SUPER_USER?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Status","Return Email","List Price"]:["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Status","Donation Status","Return Email","User Name","Email","List Price","Action"];
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

// For get the SoldTickets table headers
const GenerateSoldTicketHeadCells = ()=>{
  const id = globalState.profile.userRole === "logitix_user"?["e_name","e_date","e_address","e_date","tp_section","tp_payment_status","action"]:globalState.profile.userRole === roles.SUPER_USER?["e_name","e_date","e_address","e_date","tp_section","tp_payment_status","action"]:["e_name","e_date","e_address","e_date","tp_section","tp_payment_status","tp_is_support_vanderbilt_nil_fund","full_name","u_email_id","action"];
  const labels = globalState.profile.userRole === "logitix_user"?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Status","Sold Price"]:globalState.profile.userRole === roles.SUPER_USER?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Status","Your Payout"]:["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","Status","Donation Status","User Name","Email","Sold Price"];
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

/*For get the DeistAndReturnTicket table headers */
const GenerateDelistAndReturnTicketHeadCells = ()=>{
  const id = globalState.profile.userRole === "logitix_user"?["e_name","e_date","e_address","tp_delist_requested_email","e_date","tp_section"]:globalState.profile.userRole === roles.SUPER_USER?["e_name","e_date","e_address","tp_delist_requested_email","e_date","tp_section"]:["e_name","e_date","e_address","tp_delist_requested_email","e_date","tp_section","full_name","u_email_id","tp_is_support_vanderbilt_nil_fund"];
  const labels = globalState.profile.userRole === "logitix_user"?["Events","Date","Venue","Return Email","Venue Time","Ticket Placements,Section,Row,Seat"]:globalState.profile.userRole === roles.SUPER_USER?["Events","Date","Venue","Return Email","Venue Time","Ticket Placements,Section,Row,Seat"]:["Events","Date","Venue","Return Email","Venue Time","Ticket Placements,Section,Row,Seat","User Name","Email","Donation Status"];
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

// For get the UnsoldTickets table headers
const GenerateUnsoldTicketHeadCells = ()=>{
  const id = globalState.profile.userRole === "logitix_user"?["e_name","e_date","e_address","e_date","tp_section"]:globalState.profile.userRole === roles.SUPER_USER?["e_name","e_date","e_address","e_date","tp_section"]:["e_name","e_date","e_address","e_date","tp_section","full_name","u_email_id","tp_is_support_vanderbilt_nil_fund"];
  const labels = globalState.profile.userRole === "logitix_user"?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat"]:globalState.profile.userRole === roles.SUPER_USER?["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat"]:["Events","Date","Venue","Venue Time","Ticket Placements,Section,Row,Seat","User Name","Email","Donation Status"];
  const headCells = id.map((id, index) => ({
      id,
      label: labels[index],
    }));
    return headCells;
}

  useEffect(()=>{
    const tempValue = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempValue.globalSearch.searchtext = "";
      tempValue.globalSearch.affiliateUsersClicked = false;
      handleGlobalState(tempValue);
    }
    else if(globalState.soldTickets.failed){
      tempValue.soldTickets.failed = false
      tempValue.globalSearch.searchtext = "";
      tempValue.soldTickets.emailId = "";
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  useEffect(() => {
    if (globalState.error.errorClicked) {
      switch (globalState.error.status) {
        case "List":
          setActiveTab(1);
          break;
        case "Delist":
          setActiveTab(0);
          break;
        case "DelistInProgress":
          setActiveTab(0);
          break;
        case "Sold":
          setActiveTab(2);
          break;
        case "ToBeVerified":
          setActiveTab(0);
          break;
        case "Verified":
          setActiveTab(0);
          break;
        case "Return":
          setActiveTab(3);
          break;
        case "Unsold":
          setActiveTab(4);
          break;
        default:
          setActiveTab(0);
          break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState.error.errorClicked]);

  useEffect(()=>{
    setTicketCount(0)
    setSelectedTickets([])
    setSelected([])
  },[activeTab]);
  
  return (
    <ThemeProvider theme={theme}>
      <div className={styles.maincontainer}>
        <div className={styles.ticketContainer}>
          <div className={styles.TabsStyle}>
            <Tabs value={activeTab} onChange={handleChangeTab}
            variant='scrollable'
            scrollButtons={false}>
              <Tab label={`Manage Tickets ${(globalState?.manageTicketFilter?.notificationFilterDataCount !== 0 && globalState?.notification?.notificationClicked)?`(${globalState?.manageTicketFilter?.notificationFilterDataCount})`:(globalState?.manageTicketFilter?.errorFilterDataCount !== 0 && globalState.error.errorClicked)?`(${globalState?.manageTicketFilter?.errorFilterDataCount})`:''}`} />
              <Tab label={`List Tickets ${(globalState?.listTicketFilter?.notificationFilterDataCount !== 0 && globalState?.notification?.notificationClicked)?`(${globalState?.listTicketFilter?.notificationFilterDataCount})`:(globalState?.listTicketFilter?.errorFilterDataCount !== 0 && globalState.error.errorClicked)?`(${globalState?.listTicketFilter?.errorFilterDataCount})`:''}`} />
              <Tab label={`Sold Tickets ${(globalState?.soldTicketFilter?.notificationFilterDataCount !== 0 && globalState?.notification?.notificationClicked)?`(${globalState?.soldTicketFilter?.notificationFilterDataCount})`:(globalState?.soldTicketFilter?.errorFilterDataCount !== 0 && globalState.error.errorClicked)?`(${globalState?.soldTicketFilter?.errorFilterDataCount})`:''}`} />
              <Tab label={`Delist And Return ${(globalState?.delistAndReturnTicketFilter?.notificationFilterDataCount !== 0 && globalState?.notification?.notificationClicked)?`(${globalState?.delistAndReturnTicketFilter?.notificationFilterDataCount})`:(globalState?.delistAndReturnTicketFilter?.errorFilterDataCount !== 0 && globalState.error.errorClicked)?`(${globalState?.delistAndReturnTicketFilter?.errorFilterDataCount})`:''}`} />
              <Tab label={`Delist and Unsold ${(globalState?.unsoldTicketFilter?.notificationFilterDataCount !== 0 && globalState?.notification?.notificationClicked)?`(${globalState?.unsoldTicketFilter?.notificationFilterDataCount})`:(globalState?.unsoldTicketFilter?.errorFilterDataCount !== 0 && globalState.error.errorClicked)?`(${globalState?.unsoldTicketFilter?.errorFilterDataCount})`:''}`} />
            </Tabs>
          </div>
          <div className={styles.actionsblock}>
          {(globalState?.globalSearch?.searchtext !== '' && activeTab === 0 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Search Results<span className={styles.filterCount}>({manageTicketList?.filtermanagetickets_aggregate?.aggregate?.count})</span></div>}
          {(globalState?.globalSearch?.searchtext !== '' && activeTab === 1 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Search Results<span className={styles.filterCount}>({listTicketList?.filterlisttickets_aggregate?.aggregate?.count})</span></div>}
          {(globalState?.globalSearch?.searchtext !== '' && activeTab === 2 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Search Results<span className={styles.filterCount}>({soldTicketList?.FilterSoldTickets_aggregate?.aggregate?.count})</span></div>}
          {(globalState?.globalSearch?.searchtext !== '' && activeTab === 3 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Search Results<span className={styles.filterCount}>({delistAndReturnTicketList?.filterreturntickets_aggregate?.aggregate?.count})</span></div>}
          {(globalState?.globalSearch?.searchtext !== '' && activeTab === 4 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Search Results<span className={styles.filterCount}>({unsoldTicketList?.filterUnsoldTickets_aggreagate?.aggregate?.count})</span></div>}

            {(globalState?.manageTicketFilter?.isFilter && activeTab === 0 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Filter Results<span className={styles.filterCount}>({manageTicketList?.filtermanagetickets_aggregate?.aggregate?.count})</span></div>}
            {(globalState?.listTicketFilter?.isFilter && activeTab === 1 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Filter Results<span className={styles.filterCount}>({listTicketList?.filterlisttickets_aggregate?.aggregate?.count})</span></div>}
            {(globalState?.soldTicketFilter?.isFilter && activeTab === 2 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Filter Results<span className={styles.filterCount}>({soldTicketList?.FilterSoldTickets_aggregate?.aggregate?.count})</span></div>}
            {(globalState?.delistAndReturnTicketFilter?.isFilter && activeTab === 3 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Filter Results<span className={styles.filterCount}>({delistAndReturnTicketList?.filterreturntickets_aggregate?.aggregate?.count})</span></div>}
            {(globalState?.unsoldTicketFilter?.isFilter && activeTab === 4 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) && <div className={styles.filterResultCount}>Filter Results<span className={styles.filterCount}>({unsoldTicketList?.filterUnsoldTickets_aggreagate?.aggregate?.count})</span></div>}

            {(activeTab === 0 && globalState.profile.userRole !==roles.SUPER_USER) ? (
              <div className={styles.bulkaction} onClick={handleClickOpenmenu}>
                <div>Bulk Action</div>
                <div className={styles.dropdown}>
                  <img src={dropdownIcon} alt="dropdownicon" />
                </div>
              </div>
            ) : (
              ""
            )}
            {(activeTab === 0 && globalState.profile.userRole !==roles.SUPER_USER) &&(
            <Menu
              id="long-menu"
              MenuListProps={{
                "aria-labelledby": "long-button",
                disablePadding: true,
              }}
              transformOrigin={{
                horizontal: "center",
                vertical: "top",
              }}
              anchorOrigin={{
                horizontal: "center",
                vertical: "bottom",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseMenu}
              classes={{
                paper: styles.validDropdown,
                list: styles.menulistStyle
              }}
            >
              <MenuItem
               classes={{
                root: styles.menuItemvalid
               }}
                className={styles.menuItemsStyleValid}
                onClick={(e) => modifyValidStatus(true)
                }
              >
                Valid
              </MenuItem>
              <MenuItem
              classes={{
                root: styles.menuItemvalid
               }}
                className={styles.menuItemsStyleInvalid}
                onClick={(e) => modifyValidStatus(false)}
              >
                Invalid
              </MenuItem>
              <MenuItem
              classes={{
                root: styles.menuItemvalid
               }}
                className={styles.menuItemsStylePublish}
                onClick={(e) => handlepublish()}
              >
                Publish
              </MenuItem>
              <MenuItem
              classes={{
                root: styles.menuItemvalid
               }}
                className={styles.menuItemsStyleReturn}
                onClick={(e) => handleReturn()}
              >
                Return
              </MenuItem>
            </Menu>
            )}
            {(activeTab === 1 && globalState.profile.userRole ===roles.SUPER_USER)&& (
              <div className={styles.bulkActionContainer}>
                <div className={styles.bulkaction}>
                  <Button 
                    onClick={handleOpenDialogEditPrice}
                    sx={{textTransform: 'none',
                      fontFamily: 'var(--body-b3-12-semibold-left)',
                      fontSize:'var(--body-b2-14-semibold-left-size)',
                      color:'var(--branding-secondary)'
                    }}>
                    Edit Price
                  </Button>
                </div>
                <div className={styles.bulkaction}>
                  <Button 
                    onClick={handleOpenDialogBulkDelist}
                    sx={{textTransform: 'none',
                      fontFamily: 'var(--body-b3-12-semibold-left)',
                      fontSize:'var(--body-b2-14-semibold-left-size)',
                      color:'var(--branding-secondary)'
                    }}
                  >
                  Delist
                  </Button>
                </div>
              </div>
                       )}



            {activeTab === 0 && <div className={globalState.manageTicketFilter.isFilter ? styles.activeFilter : styles.filter} onClick={handleClickopenFilter}>
              <span className={styles.filterIconStyle}>
               <img src={GreyFilterIcon} alt={"filtericon"} /> 
              </span>
              <span>Filter</span>
            </div>}
            {activeTab === 1 && <div className={globalState?.listTicketFilter?.isFilter ? styles.activeFilter : styles.filter} onClick={handleClickopenFilter}>
              <span className={styles.filterIconStyle}>
                <img src={GreyFilterIcon} alt={"filtericon"} />
              </span>
              <span>Filter</span>
            </div>}
            {activeTab === 2 && <div className={globalState?.soldTicketFilter?.isFilter ? styles.activeFilter : styles.filter} onClick={handleClickopenFilter}>
              <span className={styles.filterIconStyle}>
                <img src={GreyFilterIcon} alt={"filtericon"} />
              </span>
              <span>Filter</span>
            </div>}
            {activeTab === 3 && <div className={globalState?.delistAndReturnTicketFilter?.isFilter ? styles.activeFilter : styles.filter} onClick={handleClickopenFilter}>
              <span className={styles.filterIconStyle}>
                <img src={GreyFilterIcon} alt={"filtericon"} />
              </span>
              <span>Filter</span>
            </div>}
            {activeTab === 4 && <div className={globalState?.unsoldTicketFilter?.isFilter ? styles.activeFilter : styles.filter} onClick={handleClickopenFilter}>
              <span className={styles.filterIconStyle}>
                <img src={GreyFilterIcon} alt={"filtericon"} />
              </span>
              <span>Filter</span>
            </div>}
          </div>
          <Menu
            anchorEl={anchorElFilter}
            id="account-menu"
            open={openFilter}
            onClose={handleClose}
            transformOrigin={{ horizontal: "left", vertical: "top" }}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
            MenuListProps={{
              disablePadding: true,
            }}
            classes={{
              paper: styles.customMenu,
            }}
          >
            {activeTab === 0 && <ManageTicketFilterDropdown activetab={activeTab} handleCloseFilterDropDown={handleClose}/>}
            {activeTab === 1 && <ListTicketFilterDropdown activetab = {activeTab} handleCloseFilterDropDown={handleClose}/>}
            {activeTab === 2 && <SoldTicketFilterDropdown activetab = {activeTab} handleCloseFilterDropDownForSold={handleClose}/>}
            {activeTab === 3 && <DelistAndReturnFilterDropdown activetab = {activeTab} handleCloseFilterDropDown={handleClose}/>}
            {activeTab === 4 && <DelistAndUnsoldFilterDropdown activetab = {activeTab} handleCloseFilterDropDown={handleClose}/>}
          </Menu>
        </div>
        {activeTab === 0 && 
            <ManageTickets
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            setCurrentPage = {setCurrentPage}
            checking={checking}
            setChecking = {setChecking}
            manageTicketList={manageTicketList}
            setManageTicketList={setManageTicketList}
            selected={selected}
            setSelected={setSelected}
            columnTypes={columnTypes}
            setColumnTypes={setColumnTypes}
            sortType={sortType}
            setSortType={setSortType}
            GenerateManageTicketHeadCells={GenerateManageTicketHeadCells}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handlePageChange={handlePageChange}
            selectedTickets= {selectedTickets}
            setSelectedTickets = {setSelectedTickets}
            />
        }
        {activeTab === 1 && 
            <ListTickets 
            rowsPerPage={ListRowsPerPage}
            currentPage={currentPageList}
            setCurrentPage = {setCurrentPageList}
            checking={checking}
            setChecking = {setChecking}
            listTicketList={listTicketList}
            setListTicketList={setListTicketList}
            selected={selected}
            setSelected={setSelected}
            columnTypes={columnTypes}
            setColumnTypes={setColumnTypes}
            sortType={sortType}
            setSortType={setSortType}
            GenerateListTicketHeadCells={GenerateListTicketHeadCells}
            handleChangeRowsPerPage={handleChangeListRowsPerPage}
            handlePageChange={handlePageChangeList}
            activeTab = {activeTab}
            selectedTickets= {selectedTickets}
            setSelectedTickets = {setSelectedTickets}
            />}

           {activeTab === 2 && 
            <SoldTickets 
            rowsPerPage={SoldRowsPerPage}
            currentPage={currentPageSold}
            setCurrentPage = {setCurrentPageSold}
            checking={checking}
            setChecking = {setChecking}
            soldTicketList={soldTicketList}
            setsoldTicketList={setSoldTicketList}
            selected={selected}
            setSelected={setSelected}
            columnTypes={columnTypes}
            setColumnTypes={setColumnTypes}
            sortType={sortType}
            setSortType={setSortType}
            GenerateSoldTicketHeadCells={GenerateSoldTicketHeadCells}
            handleChangeRowsPerPage={handleChangeSoldRowsPerPage}
            handlePageChange={handlePageChangeSold}
            activeTab = {activeTab}
            />}

            {activeTab === 3 && 
            <DelistAndReturnTickets 
            rowsPerPage={ReturnRowsPerPage}
            currentPage={currentPageReturn}
            setCurrentPage = {setCurrentPageReturn}
            checking={checking}
            setChecking = {setChecking}
            delistAndReturnTicketList={delistAndReturnTicketList}
            setDelistAndReturnTicketList={setDelistAndReturnTicketList}
            selected={selected}
            setSelected={setSelected}
            columnTypes={columnTypes}
            setColumnTypes={setColumnTypes}
            sortType={sortType}
            setSortType={setSortType}
            GenerateDelistAndReturnTicketHeadCells={GenerateDelistAndReturnTicketHeadCells}
            handleChangeRowsPerPage={handleChangeReturnRowsPerPage}
            handlePageChange={handlePageChangeReturn}
            activeTab = {activeTab}
            />}

            {activeTab === 4 && 
            <DelistAndUnsold 
            rowsPerPage={UnsoldRowsPerPage}
            currentPage={currentPageUnsold}
            setCurrentPage = {setCurrentPageUnsold}
            checking={checking}
            setChecking = {setChecking}
            unsoldTicketList={unsoldTicketList}
            setUnsoldTicketList={setUnsoldTicketList}
            selected={selected}
            setSelected={setSelected}
            columnTypes={columnTypes}
            setColumnTypes={setColumnTypes}
            sortType={sortType}
            setSortType={setSortType}
            GenerateUnsoldTicketHeadCells={GenerateUnsoldTicketHeadCells}
            handleChangeRowsPerPage={handleChangeUnsoldRowsPerPage}
            handlePageChange={handlePageChangeUnsold}
            activeTab = {activeTab}
            />}
      </div>
      <Dialog
          open={openDialog}
          onClose={(_event, reason) => {
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
            handleCloseDialog();
          }}
          PaperComponent={StyledComponent}
        >
          <PublishPopup
            handleClose={handleCloseDialog}
            title={"Publish Tickets"}
            subTitle={"Do you want to publish the tickets"}
            handleAllow ={handleAllowpublish}
            bulkTicketsPublish = {selectedVerified()}
          />
        </Dialog>
        <Dialog
          open={openDialogReturn}
          PaperComponent={StyledComponent}
        >
              <PublishPopup title="Return?" subTitle="Kindly confirm - Once you returned the ticket to the sender" returnTicket={true} handleAllow={handleAllowReturn} handleClose={handleCloseDialogReturn}/>
        </Dialog>
        <Dialog
                open={openDialogBulkDelist}
                PaperComponent={StyledComponent}
              >
              <PublishPopup title="Delist?" subTitle="Confirm if you would like to remove your inventory from all marketplaces. Once your tickets are delisted we will transfer your tickets back to you" delist={true} handleAllow={handleAllowDelist} handleClose={handleCloseDialogBulkDelist}/>
        </Dialog>
        <Dialog
            open={openDialogEditPrice}
            PaperComponent={StyledComponent}
        >
            <NumberEditPopup
              title="Edit List Price"
              label="Price"
              prefix="$"
              defaultValue={""}
              minValue={0}
              maxValue={100000}
              onSubmit={handleBulkPriceUpdate}
              onClose={handleCloseDialogEditPrice}
            />
        </Dialog>
    </ThemeProvider>
  );
};
export default Tickets;
